import React from 'react';

const RootsSun = (props) => {
  const { radius, cells } = props;
  const base = cells[1].background;

  return (
    <svg width={`${radius * 2.4}px`} height={`${radius * 2.4}px`} x={`-${radius * 1.2}px`} y={`-${radius * 1.2}px`} viewBox="0 0 247 247" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Canvas">
        <g id="Vector">
          <use xlinkHref="#path0_fill" fill={base} />
          <use xlinkHref="#path1_fill" fill={base} />
          <use xlinkHref="#path2_fill" fill={base} />
          <use xlinkHref="#path3_fill" fill={base} />
          <use xlinkHref="#path4_fill" fill={base} />
          <use xlinkHref="#path5_fill" fill={base} />
          <use xlinkHref="#path6_fill" fill={base} />
          <use xlinkHref="#path7_fill" fill={base} />
          <use xlinkHref="#path8_fill" fill={base} />
          <use xlinkHref="#path9_fill" fill={base} />
          <use xlinkHref="#path10_fill" fill={base} />
          <use xlinkHref="#path11_fill" fill={base} />
          <use xlinkHref="#path12_fill" fill={base} />
          <use xlinkHref="#path13_fill" fill={base} />
          <use xlinkHref="#path14_fill" fill={base} />
          <use xlinkHref="#path15_fill" fill={base} />
        </g>
      </g>
      <defs>
        <path id="path0_fill" d="M 192.893 52.965C 194.629 41.4379 194.252 29.7579 191.766 18.5359C 181.085 20.9095 170.855 25.2422 161.522 31.2424C 174.493 35.4257 185.474 43.0977 192.893 52.965Z" />
        <path id="path1_fill" d="M 161.088 31.2892C 158.086 20.0273 153.085 9.47171 146.333 0.181142C 137.487 6.63544 129.835 14.7048 123.671 23.9433C 137.23 22.582 150.354 25.216 161.088 31.2892Z" />
        <path id="path2_fill" d="M 221.542 122.633C 230.905 115.712 238.881 107.186 245.042 97.4891C 235.814 91.6 225.523 87.4159 214.689 85.0462C 220.909 97.1945 223.26 110.399 221.542 122.633Z" />
        <path id="path3_fill" d="M 214.351 84.7711C 220.176 74.6804 224.089 63.6735 225.871 52.3198C 215.061 50.6164 203.956 50.9013 193.077 53.0664C 203.625 61.7103 211.047 72.8716 214.351 84.7711Z" />
        <path id="path4_fill" d="M 193.547 194.677C 205.051 196.417 216.708 196.039 227.908 193.548C 225.539 182.846 221.215 172.596 215.226 163.244C 211.051 176.241 203.394 187.244 193.547 194.677Z" />
        <path id="path5_fill" d="M 215.181 162.811C 226.42 159.803 236.955 154.792 246.228 148.026C 239.786 139.163 231.733 131.497 222.512 125.32C 223.871 138.906 221.242 152.056 215.181 162.811Z" />
        <path id="path6_fill" d="M 124.018 223.384C 130.925 232.765 139.435 240.757 149.113 246.93C 154.99 237.684 159.166 227.373 161.531 216.518C 149.407 222.75 136.228 225.105 124.018 223.384Z" />
        <path id="path7_fill" d="M 161.806 216.178C 171.876 222.014 182.862 225.935 194.193 227.721C 195.893 216.889 195.609 205.763 193.448 194.862C 184.821 205.432 173.682 212.868 161.806 216.178Z" />
        <path id="path8_fill" d="M 53.3351 194.331C 51.5988 205.858 51.9754 217.538 54.4622 228.76C 65.1433 226.386 75.3731 222.053 84.706 216.053C 71.7346 211.87 60.7538 204.198 53.3351 194.331Z" />
        <path id="path9_fill" d="M 85.5052 215.64C 88.5078 226.902 93.5084 237.457 100.261 246.748C 109.107 240.294 116.758 232.224 122.923 222.986C 109.364 224.347 96.2392 221.713 85.5052 215.64Z" />
        <path id="path10_fill" d="M 23.9573 124.259C 14.5947 131.18 6.61828 139.706 0.457163 149.403C 9.68491 155.292 19.9761 159.476 30.8099 161.846C 24.5899 149.697 22.2396 136.493 23.9573 124.259Z" />
        <path id="path11_fill" d="M 31.877 163.261C 26.0525 173.352 22.1392 184.359 20.3575 195.712C 31.1674 197.416 42.2723 197.131 53.151 194.966C 42.6027 186.322 35.1811 175.16 31.877 163.261Z" />
        <path id="path12_fill" d="M 53.0472 52.2533C 41.5427 50.5136 29.8858 50.891 18.6858 53.3827C 21.0548 64.0848 25.379 74.3348 31.3673 83.6861C 35.5424 70.6891 43.1992 59.6867 53.0472 52.2533Z" />
        <path id="path13_fill" d="M 31.0467 84.1196C 19.8071 87.1281 9.27226 92.1386 0 98.9045C 6.44158 107.768 14.495 115.434 23.7154 121.611C 22.3567 108.025 24.9855 94.8748 31.0467 84.1196Z" />
        <path id="path14_fill" d="M 122.575 23.5465C 115.668 14.1654 107.159 6.17328 97.4809 0C 91.6034 9.24597 87.4275 19.5575 85.0625 30.4127C 97.1869 24.1804 110.366 21.8254 122.575 23.5465Z" />
        <path id="path15_fill" d="M 84.7878 30.7515C 74.717 24.9155 63.7317 20.9945 52.4005 19.2093C 50.7004 30.0404 50.9847 41.1673 53.1456 52.0675C 61.7725 41.4984 72.9117 34.0621 84.7878 30.7515Z" />
      </defs>
    </svg>
  )
}
export default RootsSun;

export function resize(props) {
  const { radius, minY, minX, maxY, maxX } = props;
  return {
    ...props,
    minY: minY + radius * .2,
    minX: minX + radius * .2,
    maxY: maxY + radius * .2,
    maxX: maxX + radius * .2,
  };
}




// WEBPACK FOOTER //
// ./src/core/thematic/rootstech/sunflower.js